var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.16667V2C1.5 1.72386 1.67411 1.5 1.88889 1.5H6.94444C7.15924 1.5 7.33333 1.72386 7.33333 2V5.16667C7.33333 5.44283 7.15924 5.66667 6.94444 5.66667H1.88889C1.67411 5.66667 1.5 5.44283 1.5 5.16667Z",
    stroke: "#1A1C23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.6V9.9C1.5 9.40294 1.67411 9 1.88889 9H6.94444C7.15924 9 7.33333 9.40294 7.33333 9.9V15.6C7.33333 16.0971 7.15924 16.5 6.94444 16.5H1.88889C1.67411 16.5 1.5 16.0971 1.5 15.6Z",
    stroke: "#1A1C23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 8.5V2C10.6667 1.72386 10.8408 1.5 11.0556 1.5H16.1111C16.3259 1.5 16.5 1.72386 16.5 2V8.5C16.5 8.77617 16.3259 9 16.1111 9H11.0556C10.8408 9 10.6667 8.77617 10.6667 8.5Z",
    stroke: "#1A1C23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 16V12.8333C10.6667 12.5572 10.8408 12.3333 11.0556 12.3333H16.1111C16.3259 12.3333 16.5 12.5572 16.5 12.8333V16C16.5 16.2762 16.3259 16.5 16.1111 16.5H11.0556C10.8408 16.5 10.6667 16.2762 10.6667 16Z",
    stroke: "#1A1C23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.5f7c20e30d4adac98ffd239e7f8eef4c.svg";
export { ForwardRef as ReactComponent };